module.exports = __webpack_public_path__ + "static/media/OffHand_2.3f8e0c8e.jpg";